import { Component, OnChanges, OnDestroy, OnInit, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseFormComponent } from '../../../../shared/modules/ui/components/abstract/a-base-form.component';
import { ABaseModelPaneWToolbarComponent } from '../../../../shared/modules/ui/components/abstract/a-base-model-pane-w-toolbar.component';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, Vehicle, VehicleService } from '../../../../shared/sdk';
import { HelperService } from '../../../consumer/services/helper.service';
import { VehicleFormComponent } from '../vehicle-form/vehicle-form.component';

@Component({
  selector: 'app-vehicle-details-tab-maintenance-recs',
  templateUrl: './vehicle-details-tab-maintenance-recs.component.html',
  styleUrls: ['./vehicle-details-tab-maintenance-recs.component.scss'],
})
export class VehicleDetailsTabMaintenanceRecsComponent
  extends ABaseModelPaneWToolbarComponent<Vehicle>
  implements OnInit, OnChanges, OnDestroy
{
  isBiller$: Observable<boolean>;
  $selectedArray$: BehaviorSubject<VehicleService[]> = new BehaviorSubject([]);
  selected$: Observable<VehicleService> = new Observable();

  constructor(
    public config: ConfigService,
    protected logger: LoggerService,
    protected ui: UiService,
    protected helper: HelperService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
  ) {
    super(logger, ui, dss);

    this.isBiller$ = this.config.hasAnyRole$(['SU', 'BILLER']);
    this.selected$ = this.$selectedArray$.pipe(map(ids => (ids && ids.length ? ids[0] : null)));
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.caption = 'Vehicle Maintenance Records';
  }

  protected get ModelClass(): any {
    return Vehicle;
  }

  protected get FormComponent(): Type<ABaseFormComponent<Vehicle>> {
    return VehicleFormComponent;
  }

  protected get observeModels(): any[] {
    return [this.ModelClass];
  }

  grid_onSelected(vehicles: VehicleService[]) {
    if (vehicles && vehicles.length) {
      this.$selectedArray$.next(vehicles);
    } else {
      this.$selectedArray$.next([]);
    }
  }
}
